export default "__VITE_ASSET__Cz1Lh1Uc__"